module.exports = __webpack_public_path__ + "assets/techly.ca8c681c.svg";